import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'player-play', 'IconPlayerPlay', [["path",{"d":"M7 4v16l13 -8z","key":"svg-0"}]]);